var exports = {
  "zr": "root__LyUll9",
  "y1": "bannerBase__C-Us33",
  "kL": "container__r8Vr2R" + " " + "bannerBase__C-Us33",
  "op": "infoContainer__TY4lAD" + " " + "bannerBase__C-Us33",
  "Kk": "icon__WvePuJ",
  "G": "infoIcon__VIja8_",
  "Qq": "text__SQiNGJ",
  "aV": "infoText__u-MM61",
  "G5": "command__hilctP",
  "cL": "copyButton__nZG6HD",
  "YI": "docsButton__JzmhHk",
};

module.exports = exports;
